
  



async function addToCart(item) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  });
  if (!response.ok) throw new Error("Failed to add item to cart");
  return response.json();
}

  
  let toastShown = false;
function showToast(message, type = 'success') {

  if(!toastShown){
toastShown=true;
    const toastContainer = document.getElementById('toast-container');
    
    // Create toast element
    const toast = document.createElement('div');
    toast.classList.add('toast', type); // Directly add the type as a class

    toast.innerText = message;

    // Append the toast to the container
    toastContainer.appendChild(toast);

    // Remove the toast after the animation
    setTimeout(() => {
      toastShown=false;
       toast.remove();
    }, 4000); // Match the animation duration
  }
}

  
function resetAddonModal() {
  const skipButton = document.querySelector('.close-modal');
  if (skipButton) {
    skipButton.removeAttribute('disabled');
    skipButton.removeAttribute('aria-disabled');
    skipButton.classList.remove('hidden');
    skipButton.style.display = '';
    const btnText = skipButton.querySelector('.button-text');
    if (btnText) {
      btnText.textContent = 'Skip';
      btnText.classList.remove('hidden');
    } else {
      skipButton.textContent = 'Skip';
    }
  }

  const continueButton = document.querySelector('.continue-modal');
  if (continueButton) {
    continueButton.removeAttribute('disabled');
    continueButton.removeAttribute('aria-disabled');
    const cText = continueButton.querySelector('.button-text');
    if (cText) {
      cText.classList.remove('hidden');
      const selectedCount = document.querySelectorAll('.addon-checkbox:checked').length;
      cText.textContent = selectedCount > 0 ? `Continue (${selectedCount})` : 'Continue';
    } else {
      continueButton.textContent = 'Continue';
    }
  }
}
window.resetAddonModal = resetAddonModal;

function showModal() {
  window.suppressCartDrawer = true;
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawer.classList.remove('active', 'poptop', 'animate');
    drawer.style.display = 'none';
    if (typeof drawer.close === 'function') {
      try { drawer.close(); } catch(e) {}
    }
  }
  hideGlobalPreloader();
  resetAddonModal();

  const modal = document.getElementById('addonModal');
  if (modal) {
    modal.style.display = 'flex';
    document.documentElement.classList.add('overflow-hidden');
  }
}

function closeModal() {
  const modal = document.getElementById('addonModal');
  if (modal) {
    modal.style.display = 'none';
    document.documentElement.classList.remove('overflow-hidden');
  }
  resetAddonModal();
}

function ensurePreloaderStyles() {
  if (!document.getElementById('mbtl-preloader-styles')) {
    var style = document.createElement('style');
    style.id = 'mbtl-preloader-styles';
    style.textContent = `
      .mbtl-preloader, #mbtl-preloader {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        z-index: 2147483647 !important;
        pointer-events: auto !important;
        opacity: 1 !important;
        visibility: visible !important;
        background: #ffffff !important;
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box !important;
        transition: opacity 0.09s ease, visibility 0.09s ease !important;
      }
      .mbtl-preloader.is-done {
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        display: none !important;
      }
      .mbtl-preloader-track {
        position: relative !important;
        width: 130px !important;
        max-width: 48vw !important;
        height: 2px !important;
        background-color: var(--mbt-preloader-track, #e5e7eb) !important;
        border-radius: 999px !important;
        overflow: hidden !important;
      }
      .mbtl-preloader-bar {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        bottom: 0 !important;
        width: 35% !important;
        height: 100% !important;
        background-color: var(--mbt-preloader-color, #000000) !important;
        border-radius: 999px !important;
        transform: translate3d(0, 0, 0);
        will-change: transform;
        animation: mbtlPingPong 0.7s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite alternate !important;
      }
      @keyframes mbtlPingPong {
        0% { transform: translate3d(0, 0, 0); }
        100% { transform: translate3d(85px, 0, 0); }
      }
    `;
    document.head.appendChild(style);
  }
}

function showGlobalPreloader() {
  ensurePreloaderStyles();

  var preloader = document.getElementById('mbtl-preloader');
  if (!preloader) {
    preloader = document.createElement('div');
    preloader.id = 'mbtl-preloader';
    preloader.className = 'mbtl-preloader';
    preloader.setAttribute('aria-hidden', 'true');
    preloader.innerHTML = '<div class="mbtl-preloader-track"><div class="mbtl-preloader-bar"></div></div>';
    document.body.appendChild(preloader);
  }

  // Ensure track and animated bar elements are present
  if (!preloader.querySelector('.mbtl-preloader-bar')) {
    preloader.innerHTML = '<div class="mbtl-preloader-track"><div class="mbtl-preloader-bar"></div></div>';
  }

  // Set explicit inline styles as rock-solid fallback to override any external stylesheet
  preloader.style.setProperty('position', 'fixed', 'important');
  preloader.style.setProperty('top', '0', 'important');
  preloader.style.setProperty('left', '0', 'important');
  preloader.style.setProperty('right', '0', 'important');
  preloader.style.setProperty('bottom', '0', 'important');
  preloader.style.setProperty('width', '100vw', 'important');
  preloader.style.setProperty('height', '100vh', 'important');
  preloader.style.setProperty('z-index', '2147483647', 'important');
  preloader.style.setProperty('background', '#ffffff', 'important');
  preloader.style.setProperty('display', 'flex', 'important');
  preloader.style.setProperty('align-items', 'center', 'important');
  preloader.style.setProperty('justify-content', 'center', 'important');
  preloader.style.setProperty('opacity', '1', 'important');
  preloader.style.setProperty('visibility', 'visible', 'important');
  preloader.style.setProperty('pointer-events', 'auto', 'important');

  preloader.classList.remove('hide-md', 'hide-lg', 'is-done');
  preloader.classList.add('is-active');
}
window.showGlobalPreloader = showGlobalPreloader;

function hideGlobalPreloader() {
  var preloader = document.getElementById('mbtl-preloader');
  if (preloader) {
    preloader.classList.remove('is-active');
    preloader.classList.add('is-done');
    preloader.style.setProperty('opacity', '0', 'important');
    preloader.style.setProperty('visibility', 'hidden', 'important');
    preloader.style.setProperty('pointer-events', 'none', 'important');
    setTimeout(function() {
      if (preloader && !preloader.classList.contains('is-active')) {
        preloader.classList.remove('is-done');
        preloader.style.display = 'none';
      }
    }, 120);
  }
}
window.hideGlobalPreloader = hideGlobalPreloader;

async function skipModal() {
  window.suppressCartDrawer = true;

  // 1. Immediately force hide and close the cart drawer so it NEVER flashes
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawer.classList.remove('active', 'poptop', 'animate');
    drawer.style.display = 'none';
    if (typeof drawer.close === 'function') {
      try { drawer.close(); } catch(e) {}
    }
  }

  // 2. Disable buttons and show loading state
  const skipButton = document.querySelector('.close-modal');
  const continueButton = document.querySelector('.continue-modal');
  if (skipButton) {
    skipButton.setAttribute('disabled', 'true');
    const sText = skipButton.querySelector('.button-text');
    if (sText) sText.textContent = 'Please wait...';
  }
  if (continueButton) {
    continueButton.setAttribute('disabled', 'true');
  }

  // 3. Immediately show our brand preloader (instant feedback on click)
  showGlobalPreloader();

  // 4. Close the addon modal immediately so the clean preloader is visible
  closeModal();

  // 5. If any product addition is currently in-flight, await it so it completes
  if (window._isAddingToCart && window._pendingCartAddPromise) {
    try {
      await window._pendingCartAddPromise;
    } catch(err) {
      console.warn('Pending cart add promise error:', err);
    }
  }

  // 6. Ensure Shopify cart session is synced and committed before navigation
  try {
    await fetch('/cart.js', {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' }
    });
  } catch(e) {
    console.warn('Cart sync check error:', e);
  }

  // 7. Clean redirect directly to main cart page with cache-busting timestamp
  var targetUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  var sep = targetUrl.indexOf('?') !== -1 ? '&' : '?';
  window.location.href = targetUrl + sep + 't=' + Date.now();
}


async function updateCartCount() {
    await fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartCount = cart.item_count;
            const cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon) {
                cartIcon.textContent = cartCount;
            }
        })
        .catch(error => console.error('Error updating cart count:', error));
}

    const checkboxes = document.querySelectorAll('.addon-checkbox');
    const skipButton = document.querySelector('.close-modal');
    const selectedItemsInfo = document.querySelector('.selected-items-info');

    function updateSelectedInfo() {
        const selectedItems = Array.from(checkboxes).filter(checkbox => checkbox.checked);
        const totalPrice = selectedItems.reduce((total, checkbox) => {
            return total + parseFloat(checkbox.getAttribute('data-product-price').replace(/[^0-9.-]+/g, ""));
        }, 0);
        
        // Ensure Skip button ALWAYS remains visible
        if (skipButton) {
            skipButton.style.display = '';
            skipButton.classList.remove('hidden');
        }

        const continueBtn = document.querySelector('.continue-modal');
        const continueText = continueBtn ? continueBtn.querySelector('.button-text') : null;

        if (selectedItems.length > 0) {
            if (continueText) {
                continueText.textContent = `Continue (${selectedItems.length})`;
            }
            if (selectedItemsInfo) {
                selectedItemsInfo.innerHTML = `${selectedItems.length} item(s) selected`;
            }
        } else {
            if (continueText) {
                continueText.textContent = 'Continue';
            }
            if (selectedItemsInfo) {
                selectedItemsInfo.innerHTML = '';
            }
        }
    }

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            const label = this.nextElementSibling;
            const addedInfoContainer = label.nextElementSibling; // This now targets the div with both 'added-text' and 'remove'
            const addedText = addedInfoContainer.querySelector('.added-text');
            const removeText = addedInfoContainer.querySelector('.remove');

            if (this.checked) {
                label.style.display = 'none';
                addedText.style.display = 'inline';
                removeText.style.display = 'inline';
                  addedInfoContainer.style.display='block'
              

                // Add an event listener for the 'X' button to remove the item
                removeText.addEventListener('click', function() {
                    checkbox.checked = false;
                    label.style.display = 'inline';
                    addedText.style.display = 'none';
                    removeText.style.display = 'none';
                  addedInfoContainer.style.display='none'
                  
                    updateSelectedInfo(); // Update info when unchecked
                });
            } else {
                  addedInfoContainer.style.display='none'
              
                label.style.display = 'inline';
                addedText.style.display = 'none';
                removeText.style.display = 'none';
            }

            updateSelectedInfo(); // Update info on change
        });
    });



// Function to add selected items to the cart
async function addSelectedToCart() {
  window.suppressCartDrawer = true;

  // 1. Immediately force hide and close the cart drawer so it NEVER flashes
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawer.classList.remove('active', 'poptop', 'animate');
    drawer.style.display = 'none';
    if (typeof drawer.close === 'function') {
      try { drawer.close(); } catch(e) {}
    }
  }

  // 2. Update button states immediately (disable to prevent double clicks and show loading text)
  const continueButton = document.querySelector('.continue-modal');
  const skipButton = document.querySelector('.close-modal');
  if (continueButton) {
    continueButton.setAttribute('disabled', 'true');
    const cText = continueButton.querySelector('.button-text');
    if (cText) {
      cText.textContent = 'Please wait...';
    }
  }
  if (skipButton) {
    skipButton.setAttribute('disabled', 'true');
  }

  // 3. Immediately show our brand preloader (instant visual feedback on click)
  showGlobalPreloader();

  // 4. Close the addon modal immediately so the clean preloader is visible
  closeModal();

  // 5. Await any in-flight product addition first
  if (window._isAddingToCart && window._pendingCartAddPromise) {
    try {
      await window._pendingCartAddPromise;
    } catch(err) {
      console.warn('Pending cart add promise error:', err);
    }
  }

  const selectedItems = [];
  document.querySelectorAll('.addon-checkbox:checked').forEach(checkbox => {
    const productId = checkbox.getAttribute('data-product-id');
    const quantity = 1; // Default quantity is 1 for each item
    if (productId) {
      selectedItems.push({
        id: productId,
        quantity: quantity,
      });
    }
  });

  var targetUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  var sep = targetUrl.indexOf('?') !== -1 ? '&' : '?';
  var finalUrl = targetUrl + sep + 't=' + Date.now();

  try {
    if (selectedItems.length > 0) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: selectedItems })
      });
      if (!response.ok) throw new Error("Failed to add addons");
      await response.json();
    }

    // Verify / sync session with Shopify before navigation
    await fetch('/cart.js', {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' }
    });

    // Clean redirect directly to main cart page with cache-busting timestamp
    window.location.href = finalUrl;
  } catch(error) {
    console.error('Error adding addons to cart:', error);
    hideGlobalPreloader();
    const modal = document.getElementById('addonModal');
    if (modal) {
      modal.style.display = 'flex';
      document.documentElement.classList.add('overflow-hidden');
    }
    resetAddonModal();
    if (typeof showToast === 'function') {
      showToast('Could not add items. Please try again.', 'error');
    }
  }
}

// Reset preloader and modal buttons when restoring page from bfcache (browser back/forward)
window.addEventListener('pageshow', function() {
  hideGlobalPreloader();
  resetAddonModal();
  window.suppressCartDrawer = false;
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawer.style.display = '';
  }
});

// Expose modal functions globally
window.showModal = showModal;
window.closeModal = closeModal;
window.skipModal = skipModal;
window.addSelectedToCart = addSelectedToCart;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', resetAddonModal);
} else {
  resetAddonModal();
}

